// extracted by mini-css-extract-plugin
export default {"container":"deleteAssets_container__jondl","deleteConfirmation":"deleteAssets_deleteConfirmation__UQ9oC","loadingButtonContent":"deleteAssets_loadingButtonContent__pfap1"};